var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 50C40.1503 50 50 40.1503 50 28C50 15.8497 40.1503 6 28 6C15.8497 6 6 15.8497 6 28C6 40.1503 15.8497 50 28 50Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0839 6.08504C13.9799 7.14401 5.02608 17.8147 6.08504 29.9188C6.30289 32.4088 6.92748 34.7654 7.88764 36.9289C9.64806 39.8026 12.0885 41.8743 14.7771 42.2987C17.2238 42.685 22.4385 42.392 23.9073 38.9677C26.3602 33.2492 20.5075 22.5655 25.7722 15.1426C29.3864 10.0466 38.5701 9.83363 41.4341 10.5782C37.2154 7.32398 31.81 5.58407 26.0839 6.08504Z",
    fill: "#FFEBCB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9412 32.5846C15.6386 34.743 11.5181 35.357 9.09966 33.3293C6.80724 31.4074 6.12667 27.5283 6.38126 24.0272C8.12007 14.5265 16.0197 6.96761 26.1076 6.08504C31.7609 5.59043 37.1019 7.28016 41.2966 10.455C38.0164 9.24082 27.4256 7.12519 22.4158 14.0898C17.0245 21.5845 22.9183 27.9191 17.9412 32.5846Z",
    fill: "#FFCC9F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4783 10.5889C37.2574 7.32779 31.8465 5.58352 26.1141 6.08504C17.0444 6.87855 9.74337 13.0688 7.09843 21.215C6.5554 24.1061 7.39251 26.7438 10.0003 27.9634C12.3757 29.0743 14.7852 28.0119 15.798 26.0208C16.8422 23.9679 17.1524 22.1272 17.464 20.2784C17.9191 17.5776 18.3772 14.8595 21.1312 11.4374C25.4794 6.03416 37.5854 9.15016 41.4783 10.5889Z",
    fill: "#FFA27C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9162 49.9149C42.0202 48.856 50.974 38.1853 49.9149 26.0813C49.6971 23.5913 49.0725 21.2346 48.1124 19.071C46.352 16.1975 43.9115 14.1258 41.2229 13.7013C38.7763 13.3151 33.5616 13.608 32.0927 17.0323C29.6399 22.7508 35.4926 33.4344 30.2277 40.8572C26.6135 45.9533 17.43 46.1663 14.5659 45.4218C18.7846 48.676 24.19 50.416 29.9162 49.9149Z",
    fill: "#67E0F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0588 23.4155C40.3614 21.2571 44.482 20.643 46.9004 22.6707C49.1928 24.5927 49.8733 28.4717 49.6187 31.9728C47.8799 41.4735 39.9803 49.0324 29.8924 49.9149C24.239 50.4096 18.8982 48.7198 14.7035 45.545C17.9836 46.7592 28.5744 48.8749 33.5843 41.9102C38.9756 34.4154 33.0818 28.081 38.0588 23.4155Z",
    fill: "#089BC6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5212 45.411C18.742 48.6723 24.1529 50.4165 29.8854 49.9149C38.9551 49.1215 46.256 42.9312 48.9011 34.785C49.444 31.894 48.6069 29.2562 45.9991 28.0365C43.6237 26.9257 41.2143 27.9882 40.2014 29.9791C39.1573 32.0322 38.8471 33.8729 38.5356 35.7216C38.0804 38.4225 37.6223 41.1404 34.8684 44.5627C30.5201 49.9659 18.414 46.8498 14.5212 45.411Z",
    fill: "#145C6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurf);
export default __webpack_public_path__ + "static/media/SURF.ddd3b29fac7509b92812f20d9aaf4d16.svg";
export { ForwardRef as ReactComponent };